import { render, staticRenderFns } from "./CandidatesPage.vue?vue&type=template&id=2d96970f&scoped=true&lang=pug"
import script from "./CandidatesPage.vue?vue&type=script&lang=js"
export * from "./CandidatesPage.vue?vue&type=script&lang=js"
import style0 from "./CandidatesPage.vue?vue&type=style&index=0&id=2d96970f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96970f",
  null
  
)

export default component.exports